/**
 * Import all libraries and modules
 */
import 'popper.js/dist/umd/popper.min'
import 'bootstrap/js/dist/collapse'
import 'bootstrap/js/dist/tab'
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper'

/**
 * Import Components
 */
import navigation from './layouts/_navigation'
import componentPosts from './components/_posts'

/**
 * Import pages
 */
import pageHome from './pages/_home'
import singleProduct from './pages/_single-product'
import archiveProduct from './pages/_archive-product'
import singleProject from './pages/_single-project'
import archiveProject from './pages/_archive-project'

/**
 * Run
 */
window.endpoint = '/wp-json/cadin/v1'
// eslint-disable-next-line no-undef
window.WP_VAR = WP_VAR
// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay])

navigation()
componentPosts()
pageHome()
singleProduct()
archiveProduct()
singleProject()
archiveProject()
